import React, { useEffect } from 'react';
import { SerializedStyles } from '@emotion/react';
import {
  trackLandingPageModuleClick,
  trackCtaDriver,
} from '../../../../../tracking/landing-page';
import type {
  FaaLandingPageModule,
  CtaDriverTrackingProps,
} from '../../../../../tracking/landing-page';

interface CtaItemStyles {
  ctaLink: SerializedStyles;
  ctaIcon: SerializedStyles;
}

interface CtaItemProps {
  module: FaaLandingPageModule;
  icon: React.ReactNode;
  href: string;
  children: React.ReactNode;
  styles: CtaItemStyles;
  testId?: string;
  ctaDriver: Omit<CtaDriverTrackingProps, 'elementTitle'>;
  onModuleRendered?: (module: FaaLandingPageModule) => void;
  onAdditionalClick?: () => void;
  modules?: FaaLandingPageModule[];
}

const CtaItem = ({
  module,
  icon,
  href,
  children,
  styles,
  testId,
  ctaDriver,
  onModuleRendered,
  onAdditionalClick,
  modules,
}: CtaItemProps): JSX.Element => {
  useEffect(() => {
    onModuleRendered?.(module);
  }, [module, onModuleRendered]);

  const handleClick = (): void => {
    onAdditionalClick?.();
    trackLandingPageModuleClick(module);
    trackCtaDriver({ ...ctaDriver, elementTitle: module, modules });
  };

  return (
    <a
      css={styles.ctaLink}
      data-testid={testId}
      href={href}
      onClick={handleClick}
      onAuxClick={handleClick}
    >
      <div css={styles.ctaIcon}>{icon}</div>
      {children}
    </a>
  );
};

export default CtaItem;
